import countries from 'i18n-iso-countries'
import deLocale from 'i18n-iso-countries/langs/de.json'
import enLocale from 'i18n-iso-countries/langs/en.json'
import nlLocale from 'i18n-iso-countries/langs/nl.json'
import itLocale from 'i18n-iso-countries/langs/it.json'
import frLocale from 'i18n-iso-countries/langs/fr.json'
import esLocale from 'i18n-iso-countries/langs/es.json'
import skLocale from 'i18n-iso-countries/langs/sk.json'
import csLocale from 'i18n-iso-countries/langs/cs.json'

const SUPPORTED_LOCALES = ['de', 'en', 'nl', 'it', 'fr', 'es', 'sk', 'cs'] as const

let localesRegistered = false

const ensureLocales = () => {
    if (localesRegistered) {
        return
    }

    countries.registerLocale(deLocale)
    countries.registerLocale(enLocale)
    countries.registerLocale(nlLocale)
    countries.registerLocale(itLocale)
    countries.registerLocale(frLocale)
    countries.registerLocale(esLocale)
    countries.registerLocale(skLocale)
    countries.registerLocale(csLocale)

    localesRegistered = true
}

const normalizeLocale = (locale?: string): (typeof SUPPORTED_LOCALES)[number] => {
    const shortLocale = (locale || 'en').toLowerCase().split('-')[0]
    if (SUPPORTED_LOCALES.includes(shortLocale as (typeof SUPPORTED_LOCALES)[number])) {
        return shortLocale as (typeof SUPPORTED_LOCALES)[number]
    }

    return 'en'
}

const resolveAlpha2Code = (countryValue: string): string | null => {
    const normalizedValue = countryValue.trim()
    const upperValue = normalizedValue.toUpperCase()

    if (/^[A-Z]{2}$/.test(upperValue)) {
        return upperValue
    }

    for (const locale of SUPPORTED_LOCALES) {
        const code = countries.getAlpha2Code(normalizedValue, locale)
        if (code) {
            return code
        }
    }

    return null
}

export const getLocalizedCountryName = (
    countryValue?: string | null,
    locale?: string
): string => {
    if (!countryValue?.trim()) {
        return ''
    }

    ensureLocales()

    const alpha2 = resolveAlpha2Code(countryValue)
    if (!alpha2) {
        return countryValue
    }

    const localeCode = normalizeLocale(locale)
    return countries.getName(alpha2, localeCode) || countryValue
}
